import React from 'react'
import UserLayout from '../../layouts/UserLayout'
import Payment from '../../components/Payment'

const UserPayment = () => {
  return (
    <UserLayout>
    <Payment />
    </UserLayout>
  )
}

export default UserPayment
